module.exports = __webpack_public_path__ + "img/logo_escuela.6a12ffd4.png";